<!--
    userHome
    myApply

    techHome
    techTask
    techHistory

    techListInspection

    channelHome
    channelHistory

    流程表单都是用的一个弹窗形式，
    弹窗形式满足不了拍照设置仅拍照功能，
    所以改成路由页面形式，工作量很大，
    用到八个组件，暂未完成
-->
<script>
import {ImagePreview} from 'vant';
// 加载中
import InnerLoading from '@/components/spinner/spinner.vue';
// 单选下拉
import Pop from '@/components/technician/temp/pop';
import DateTemp from '@/components/technician/temp/date';
import {blurRule,validateInput,} from '@/untils/common';
import {
  branchInfoList2,
  processGeneralsubmit,
  processIsinservice,
  processRemove,
  salespersonInfoList,
  branchInfoJudgeDistance,
  processIsBind, processIsCord, processFlowinit, processNewdetails, processTaskHistorical, inspectionReceiptor
} from "@/lib/request";
import {getLocalItem} from "@/untils/common";
import {ClientId} from "@/lib/cli";
import wx from "weixin-js-sdk";
import {Dialog} from "vant";
export default {
  name: 'temp',
  components:{
    InnerLoading,
    Pop,
    DateTemp
  },
  data() {
    return {
      content:'',
      submitText:'',
      paramsObj:{},
      variablesObj:{},
      siteIdObj:{},
      flowNameObj:{},
      returnObj:{},
      formDefine:{},
      formFields:[],
      historyList:[],
      innerLoading:false,
      createObj:{
        processInstanceId:'',
        formId:'',
        needSaveBrands:{},
        values:{}
      },
      isManClose: false,
      showPicker:false,
      showDatePicker:false,
      itemObj:{},
      showPickerImg:false,
      fileVideoUrl:'/api/resource/oss/upload',//接口前缀加api
      headers:{
        'isEncrypt':true,
        'Authorization': 'Bearer ' + getLocalItem('access_token'),
        'clientid' : ClientId,
      },
      loading:false,
      imgFlag1: false,
      //是否显示进度条
      imgUploadPercent1: 0,
      //进度条的进度，
      isShowUploadImg1: false,
      //显示上传按钮
      imgForm1: {
        showVideoPath: "",  //回显的变量
      },
      fileList:[],
      longitude:'',// 116.4484634399414,
      latitude: '',//39.98253631591797,
      subRateFlag:true,//ture时是编辑状态，false时不可编辑（提交按钮点击时为false）
      siteId:'',
      fixeCordObj:{}
    }
  },
  computed: {
    filteredActivities() {
      return this.historyList.length>0&&this.historyList.map(instance => {
        // 检查是否是自然人
        const isNaturalPerson = instance.formInfo?.fields?.some(
            field => field.id === 'applicanttype' && (field.value === '自然人'||field.value === '渠道')
        );
        const isNaturalCompany = instance.formInfo?.fields?.some(
            field => field.id === 'applicanttype' && (field.value === '法人')
        );
        // 自然人、渠道和法人
        if (!isNaturalPerson&&!isNaturalCompany) {
          return instance;
        }
        if(isNaturalPerson){
          // 创建新对象并过滤字段
          return {
            ...instance,
            formInfo: {
              ...instance.formInfo,
              // 如果是自然人或者渠道时，去掉以下三个字段
              // name:企业年检合格证明
              // name:企业信用报告
              // name:统一社会信用代码证
              fields: instance.formInfo.fields.filter(
                  field => !['uscc', 'ecr','aicoc'].includes(field.id)
              )
            }
          };
        }
        if(isNaturalCompany){
          // 创建新对象并过滤字段
          return {
            ...instance,
            formInfo: {
              ...instance.formInfo,
              // 如果是法人时，去掉以下一个字段
              // name:无犯罪证明
              fields: instance.formInfo.fields.filter(
                  field => !['policecertificate'].includes(field.id)
              )
            }
          };
        }
      });
    },
    firstItemValue() {
      return this.formFields[0]?.id==='siteid'?this.formFields[0]?.value:null;
    },
  },
  watch: {
    // siteIdObj: {
    //   handler(newVal) {
    //     if(newVal&&newVal.branchId){
    //       this.formFields.map((v)=>{
    //         if(v.id==='siteid'){
    //           v.value = newVal.branchId+'';
    //         }
    //       });
    //       this.performSearch(newVal.branchId);
    //     }
    //   },
    //   immediate: true, // 立即执行一次
    //   deep: true,      // 如果是对象/数组，深度监听
    // },
    newSiteId(newVal){
      if(this.formFields[0]?.id==='siteid'){
        this.formFields[0].value = newVal;
      }
    },
    firstItemValue(newVal, oldVal) {
      if (!newVal || !oldVal) return;
      if (newVal !== oldVal) {
        // 输入八位站点编号时，执行接口，回显数据
        if(newVal.length===8){
          console.log(newVal)
          this.performSearch(newVal);
        }
      }
    },
  },

  created() {
    if(this.$route.query.processDefinitionId){
      // 流程发起
      this.paramsObj = this.$route.query;
      this.getDefinitionFlow(this.$route.query);
    }else if(this.$route.query.processInstanceId&&this.$route.query.taskId){
      // 流程已发起，待处理
      this.paramsObj = this.$route.query;
      this.getActiveItemInfo(this.$route.query);
    }else if(this.$route.query.processInstanceId){
      // 流程完结详情
      this.historyObjectData(this.$route.query.processInstanceId)
    }else if(this.$route.query.siteid&&this.$route.query.id){
      // 一般巡检
      this.getCreat(this.$route.query)
    }
  },
  methods: {
    // 一般巡检
    getCreat(item){
      this.siteItem = {
        branchId:item.siteid,
        processDefinitionName:'一般巡检'
      };
      this.innerLoading = true;
      inspectionReceiptor({
        id:item.id
      }).then((res)=>{
        if(res){
          if(res.data){
            if(res.data.code===200){
              this.returnObj = res.data.data;
              let formDefine = JSON.parse(res.data.data.formModelJson);
              if(formDefine){
                this.content = 'del';
                this.submitText = '提交';
                this.formDefine = formDefine;
                if(formDefine.fields.length>0){
                  formDefine.fields.map((v)=>{
                    v.id_name = '';
                    if(v.id.indexOf('Name')!==-1){
                      v.id_name = 'name'
                    }else if(v.id.indexOf('name')!==-1){
                      v.id_name = 'name'
                    }else if(v.id.indexOf('phone')!==-1){
                      v.id_name = 'phone'
                    }else if(v.id.indexOf('identity')!==-1){
                      v.id_name = 'identity'
                    }
                    if(v.params.customDesign){
                      if(v.params.customDesign.type==='fileupload'){
                        v.files = [];
                      }else if(v.params.customDesign.type==='rate'){
                        v.socre = 0;
                        v.scoreValue = 0;
                        v.scoreValueFlag = true;
                      } else if (v.params.customDesign.type === 'date') {
                        v.dates = '';
                        v.dateValue = '';
                        v.dateValueFlag = true;
                      } else if (v.params.customDesign.type === 'select') {
                        // 复选框
                        if(v.params.customDesign.multiple){
                          v.checkList = []
                        }
                      }
                    }
                  });
                }
                this.formFields = formDefine.fields;
              }
            }else{
              this.$toast.fail(res.data.msg);
            }
            this.innerLoading = false;
          }
        }
      });
    },
    // 自动获取新站点编号
    // getNewSiteId(county) {
    //   if (!county) {
    //     this.$toast('没有详细地址！无法获取网点编号。');
    //     return false;
    //   }
    //   this.$http.installInfo_newSiteId({
    //     county: county,//this.returnObj.variables.address.split('/')[2]
    //   }).then((res) => {
    //     if (res) {
    //       this.newSiteId = res.toString();
    //     }
    //   });
    // },
    // 流程里面做完的流程历史数据
    historyObjectData(processInstanceId) {
      processTaskHistorical({
        processInstanceId: processInstanceId,
        handler: false
      }).then((res) => {
        if (res) {
          if (res.data) {
            if (res.data.code === 200) {
              if (res.data.data.historicActivityInstances && res.data.data.historicActivityInstances.length > 0) {
                res.data.data.historicActivityInstances.map((v, k) => {
                  if (v.formInfo.fields) {
                    v.formInfo.fields.map((i, s) => {
                      if (i.params.customDesign.type === 'fileupload') {
                        i.files = i.value ? i.value.split(',') : [];
                      } else if (i.params.customDesign.type === 'rate') {
                        i.value = parseInt(i.value) / 2;
                      }
                    })
                  }
                });
                this.historyList = res.data.data.historicActivityInstances;
              }
            } else {
              this.$toast.fail(res.data.msg);
            }
          }
        }
      });
    },
    // 流程已经生成，去处理任务
    getActiveItemInfo(item) {
      if (item.taskId) {
        this.innerLoading = true;
        /* taskId: item.taskId,
        processInstanceId: item.processInstanceId*/
        processNewdetails(item).then((res) => {
          if (res) {
            if (res.data) {
              if (res.data.code === 200) {
                if (res.data.data && res.data.data.variables.processInstanceId) {
                  this.historyObjectData(res.data.data.variables.processInstanceId);
                }
                this.returnObj = res.data.data;
                this.taskId = item.taskId;
                let formDefine = JSON.parse(res.data.data.formDefine);
                if (formDefine) {
                  this.content = '';
                  this.submitText = '提交';
                  this.formDefine = formDefine;
                  if (formDefine.fields.length > 0) {
                    formDefine.fields.map((v) => {
                      v.showItem = true;
                      v.id_name = '';
                      if (v.id.indexOf('Name') !== -1) {
                        v.id_name = 'name'
                      } else if (v.id.indexOf('name') !== -1) {
                        v.id_name = 'name'
                      } else if (v.id.indexOf('phone') !== -1) {
                        v.id_name = 'phone'
                      } else if (v.id.indexOf('identity') !== -1) {
                        v.id_name = 'identity'
                      }
                      if (v.params.customDesign) {
                        v.value = '';
                        if (v.params.customDesign.type === 'fileupload') {
                          v.files = [];
                        } else if (v.params.customDesign.type === 'rate') {
                          v.socre = 0;
                          v.scoreValue = 0;
                          v.scoreValueFlag = true;
                        } else if (v.params.customDesign.type === 'date') {
                          v.dates = '';
                          v.dateValue = '';
                          v.dateValueFlag = true;
                        } else if (v.params.customDesign.type === 'select') {
                          // 复选框
                          if(v.params.customDesign.multiple){
                            v.checkList = []
                          }
                        }
                      }
                    });
                    this.formFields = formDefine.fields;
                    // // this.flowNameObj = item;
                    // // this.pDefinitionName = res.data.data.processDefinitionName;
                    // // 新装机，调取接口拿网点编号
                    // if (item.processInstanceName && item.processInstanceName === '新装机') {
                    //   if (!item.variables.siteid) {
                    //     this.getNewSiteId(res.data.data.variables.address.split('/')[2]);
                    //   }
                    // } else if (item.processDefinitionName && item.processDefinitionName === '新装机') {
                    //   if (!item.variables.siteid) {
                    //     this.getNewSiteId(res.data.data.variables.address.split('/')[2]);
                    //   }
                    // }
                    this.variablesObj = res.data.data.variables;
                  }
                }
              }
              this.innerLoading = false;
            }
          }
        });
      }
    },
    // 创建新流程表单接口
    getDefinitionFlow(titleNameObj){
      if(titleNameObj){
        /*processDefinitionName: titleNameObj.processDefinitionName,
        processDefinitionId: titleNameObj.processDefinitionId,
        categoryName:titleNameObj.category*/
        processFlowinit(titleNameObj).then((res)=>{
          if(res){
            if(res.data){
              if(res.data.code===200){
                this.returnObj = res.data.data;
                let formDefine = JSON.parse(res.data.data.formDefine);
                if(formDefine){
                  this.content = 'del';
                  this.submitText = '提交';
                  this.formDefine = formDefine;
                  if(formDefine.fields.length>0){
                    formDefine.fields.map((v)=>{
                      v.id_name = '';
                      if(v.id.indexOf('Name')!==-1){
                        v.id_name = 'name'
                      }else if(v.id.indexOf('name')!==-1){
                        v.id_name = 'name'
                      }else if(v.id.indexOf('phone')!==-1){
                        v.id_name = 'phone'
                      }else if(v.id.indexOf('identity')!==-1){
                        v.id_name = 'identity'
                      }
                      if(v.params.customDesign){
                        if(v.params.customDesign.type==='fileupload'){
                          v.files = [];
                        }else if(v.params.customDesign.type==='rate'){
                          v.socre = 0;
                        }
                      }
                    });
                    this.flowNameObj = titleNameObj;
                    this.formFields = formDefine.fields;
                  }
                }
              } else {
                this.$toast.fail(res.data.msg);
              }
              this.innerLoading = false;
            }
          }
        });
      }
    },
    // 打分时...
    onChange(index) {
      this.formFields[index].socre = this.formFields[index].value*2;
      this.formFields[index].scoreValue = this.formFields[index].value;
    },
    onValueChange(index){
      this.$toast('点击提交按钮后，请勿重复操作数据！');
    },
    // locationImage
    // 上传照片 oss
    beforeUploadImg1(file) {
      if (
          ["image/png","image/jpg", "image/jpeg",].indexOf(file.type) === -1     //控制格式
      ) {
        this.$toast("请上传正确的图片格式");
        return false;
      }
      let fileSize = file.size / 1024 / 1024 < 500;   //控制大小  修改50的值即可
      if (!fileSize) {
        this.$toast("图片大小不能超过500MB");
        return false;
      }
      this.isShowUploadImg1 = false;
      this.imgForm1.showVideoPath = URL.createObjectURL(file);
    },
    handleSuccess(response, file, fileList, index) {
      this.loading = true;
      this.isShowUploadImg1 = true;
      this.imgFlag1 = false;
      this.imgUploadPercent1 = 0;
      //后台上传数据
      if (response.code === 200) {
        if(response.data){
          this.loading = false;
          let arr = []
          fileList.map((v)=>{
            if(v.response){
              arr.push(v.response.data.url)
            }
          });
          this.formFields[index].files = fileList;
          this.formFields[index].value = arr.join(',');

        }
      } else {
        this.$toast(response.msg);
        return false;
      }
    },
    handleExceed(files, fileList) {
      this.$toast(`最多只能上传 2 张图片`);
    },
    handleRemove(file, fileList, index) {
      let arr = []
      fileList.map((v)=>{
        if(v.response){
          arr.push(v.response.data.url);
        }
      });
      this.formFields[index].files = fileList;
      this.formFields[index].value = arr.join(',');
    },
    onIsinserviceReturn(){
      return new Promise(resolve => {
        // 后端接口返回
        processIsinservice({
          siteId:this.siteId,
          processDefinitionName:this.flowNameObj.processDefinitionName
        }).then((resData) => {
          let res = resData.data;
          if (res) {
            if (res.code && res.code === 200) {
              resolve(res.data);
            } else {
              if (res.msg) {
                this.$toast(res.msg);
              }
            }
          }
        });
      });
    },
    onIsMobileBindReturn(data){
      return new Promise(resolve => {
        // 后端接口返回
        processIsBind(data).then((resData) => {
          let res = resData.data;
          console.log(res)
          if (res) {
            if (res.code && res.code === 200) {
              resolve(res.data);
            } else {
              if (res.msg) {
                this.$toast(res.msg);
              }
            }
          }
        });
      });
    },
    // 输入8位数站点编号时，触发此方法，查询关于站点信息
    performSearch(siteId) {
      this.siteId = siteId;
      let processDefinitionName = '';
      if (this.returnObj.processDefinitionName) {
        processDefinitionName = this.returnObj.processDefinitionName;
      } else if (this.siteIdObj.processDefinitionName) {
        processDefinitionName = this.siteIdObj.processDefinitionName;
      } else if (this.flowNameObj.processDefinitionName) {
        processDefinitionName = this.flowNameObj.processDefinitionName;
      }
      if(siteId&&processDefinitionName){
        this.innerLoading = true;
        processIsinservice({
          siteId:siteId,
          processDefinitionName:processDefinitionName
        }).then((res)=>{
          if(res){
            if (res.data) {
              if (res.data.code === 200) {
                //为true时，不能创建，为false时可以创建
                if(!res.data.data){

                  if(getLocalItem('local_role')&&getLocalItem('local_role')==='销售员'){
                    // 查销售员的网点信息
                    salespersonInfoList({}).then((res)=>{
                      if(res){
                        if(res.data){
                          if(res.data.code===200){
                            if(res.data.rows.length>0){
                              // // 代销者信息
                              // if(res.data.rows[0].branchInfo){
                              //   this.agentInfo = res.data.rows[0].branchInfo;
                              //   this.siteItem = res.data.rows[0].branchInfo;
                              // }
                              // // 销售员信息
                              // this.salesObj = res.data.rows[0];
                              this.formFields.length>0&&this.formFields.map((v)=>{
                                if(v.id==='name'){
                                  //   销售员姓名
                                  v.value = res.data.rows[0].name;
                                }else if(v.id==='previousName'){
                                  //   销售员姓名
                                  v.value = res.data.rows[0].name;
                                }else if(v.id==='distributorsname'){
                                  //   销售员姓名
                                  v.value = res.data.rows[0].name;
                                }else if(v.id==='distributorname'){
                                  //   销售员姓名
                                  v.value = res.data.rows[0].name;
                                }else if(v.id==='distributorsphone'){
                                  //   销售员手机号
                                  v.value = res.data.rows[0].contact;
                                }else if(v.id==='distributorphone'){
                                  //   销售员手机号
                                  v.value = res.data.rows[0].contact;
                                }else if(v.id==='phone'){
                                  //   销售员手机号
                                  v.value = res.data.rows[0].contact;
                                }else if(v.id==='previousphone'){
                                  //   销售员手机号
                                  v.value = res.data.rows[0].contact;
                                }else if(v.id==='city'){
                                  // 地市和回显数据
                                  // 地市
                                  if(res.data.rows[0].branchInfo){
                                    v.value = res.data.rows[0].branchInfo.city;
                                  }
                                }else if(v.id==='oldAddress'){
                                  // 原始地址
                                  if(res.data.rows[0].branchInfo) {
                                    v.value = res.data.rows[0].branchInfo.address;
                                  }
                                }else if(v.id==='address'){
                                  // 原始地址
                                  if(res.data.rows[0].branchInfo) {
                                    v.value = res.data.rows[0].branchInfo.address;
                                  }
                                }
                              });
                            }
                          }else{
                            this.$toast.fail(res.data.msg);
                          }
                          this.innerLoading = false;
                        }
                      }
                    });
                  }else{
                    // 查代销者的网点信息
                    this.getSiteIdQuery(siteId,processDefinitionName);
                  }

                }else{
                  this.innerLoading = false;
                  this.$toast('当前站点正在流程中，不可重复操作！');
                  return false;
                }
              }else{
                this.$toast(res.data.msg);
              }
            }
          }
        });
      }
    },
    getSiteIdQuery(siteId,processDefinitionName){
      branchInfoList2({
        pageNum:1,
        pageSize:10,
        branchId:siteId
      }).then((res) => {
        if (res) {
          if (res.data) {
            if (res.data.code === 200) {

              /*{
                  "branchId": 54010888,
                  "businessType": "1",
                  "businessStatus": 1,
                  "closureReason": "",
                  "agentInfo": {
                      "createDept": 103,
                      "createBy": 1,
                      "createTime": "2025-05-06 03:07:50",
                      "updateBy": 1,
                      "updateTime": "2025-06-04 14:10:29",
                      "userId": "1919469099591692290",
                      "city": "北京市",
                      "agentName": "程贺",
                      "gender": "2",
                      "contact": "17610836668",
                      "idCard": "231084198308160316",
                      "deptId": 103,
                      "bankName": "中国建设银行",
                      "bankBranch": "北京",
                      "bankCardNumber": "4367421144820151666",
                      "bankCommit": 1,
                      "branchInfo": null
                  },
                  "salespersonInfos": [
                      {
                          "createDept": 103,
                          "createBy": 1,
                          "createTime": "2025-05-06 10:25:50",
                          "updateBy": null,
                          "updateTime": "2025-05-06 10:25:50",
                          "userId": "1919579324905238530",
                          "city": "西藏自治区/拉萨市",
                          "name": "陈雨欣",
                          "gender": "1",
                          "age": "33",
                          "contact": "15210826875",
                          "jobCertificate": null,
                          "registrationDate": null,
                          "deptId": 103,
                          "reviewStatus": 1
                      },
                      {
                          "createDept": 103,
                          "createBy": 1,
                          "createTime": "2025-05-06 10:30:10",
                          "updateBy": null,
                          "updateTime": "2025-05-06 10:30:10",
                          "userId": "1919580416531574786",
                          "city": "西藏自治区/拉萨市",
                          "name": "姚洋",
                          "gender": "0",
                          "age": "32",
                          "contact": "18600921552",
                          "jobCertificate": null,
                          "registrationDate": null,
                          "deptId": 103,
                          "reviewStatus": 0
                      },
                      {
                          "createDept": 103,
                          "createBy": 1,
                          "createTime": "2025-05-16 22:50:56",
                          "updateBy": null,
                          "updateTime": "2025-05-16 22:50:56",
                          "userId": "1923390716042674177",
                          "city": "西藏自治区/拉萨市",
                          "name": "程销售",
                          "gender": "0",
                          "age": "43",
                          "contact": "13910888654",
                          "jobCertificate": null,
                          "registrationDate": null,
                          "deptId": 103,
                          "reviewStatus": 1
                      }
                  ],
                  "branchType": "2",
                  "branchLevel": "一级",
                  "province": "北京市",
                  "city": "北京市",
                  "district": "朝阳区",
                  "townShip": "太阳宫乡",
                  "address": "测试地址",
                  "storefrontPhoto": "1930145101589946369",
                  "storefrontPhotoUrl": "http://dcom.unlto.com/2025/06/04/14705e599c8a492e9b0bead10ff0cfb3.jpg",
                  "storefrontAddress": "北京市朝阳区太阳宫乡太阳宫体育休闲公园",
                  "updateTime": "2025-06-04 14:10:29",
                  "deptId": 103,
                  "companyName": null,
                  "taxpayerId": null,
                  "agentCertificate": "1927267299304898561",
                  "agentCertificateCode": null,
                  "agentCertificateUrl": "http://dcom.unlto.com/2025/05/27/87513a54b2684c9ebfd047eb6c674747.jpg",
                  "ticketPhoto": "1928374276233404417",
                  "ticketPhotoUrl": "http://dcom.unlto.com/2025/05/30/7f557941745e468896d324af0e694b17.jpg",
                  "registrationDate": null,
                  "longitude": 116.4484634399414,
                  "latitude": 39.98253631591797,
                  "storefrontCommit": 1,
                  "storefrontError": 1,
                  "registrationType": "1"
              }*/
              if(res.data.rows&&res.data.rows.length>0){
                // 网点录入  查重
                if(processDefinitionName.indexOf('网点录入')!==-1){
                  this.$toast('该网点编号已存在，不可以重录录入！');
                  this.innerLoading = false;
                }else{
                  this.formFields.length>0&&this.formFields.map((v)=>{
                    // res.data.rows[0].businessType==='1'?'专营':'兼营'
                    // res.data.rows[0].branchType==='1'?'福彩':'福体'
                    // 地市和回显数据
                    if(v.id==='city'){
                      if(res.data.rows[0].area&&res.data.rows[0].area!==''){
                        v.value = `${res.data.rows[0].city}-${res.data.rows[0].area}`;
                      }else{
                        // 地市
                        v.value = res.data.rows[0].city;
                      }
                    }else if(v.id==='oldAddress'){
                      // 原始地址
                      v.value = res.data.rows[0].address;
                    }else if(v.id==='address'){
                      // 原始地址
                      v.value = res.data.rows[0].address;
                    }else if(v.id==='name'){
                      //   原代销者姓名
                      v.value = res.data.rows[0].agentInfo.agentName;
                    }else if(v.id==='previousName'){
                      //   原代销者姓名
                      v.value = res.data.rows[0].agentInfo.agentName;
                    }else if(v.id==='distributorsname'){
                      //   原代销者姓名
                      v.value = res.data.rows[0].agentInfo.agentName;
                    }else if(v.id==='distributorname'){
                      //   原代销者姓名
                      v.value = res.data.rows[0].agentInfo.agentName;
                    }else if(v.id==='distributorsphone'){
                      //   原代销者手机号
                      v.value = res.data.rows[0].agentInfo.contact;
                    }else if(v.id==='distributorphone'){
                      //   原代销者手机号
                      v.value = res.data.rows[0].agentInfo.contact;
                    }else if(v.id==='phone'){
                      //   原代销者手机号
                      v.value = res.data.rows[0].agentInfo.contact;
                    }else if(v.id==='previousphone'){
                      //   原代销者手机号
                      v.value = res.data.rows[0].agentInfo.contact;
                    }else if(v.id==='identity'){
                      //   原代销者身份证号
                      v.value = res.data.rows[0].agentInfo.idCard;
                    }else if(v.id==='previousidentity'){
                      //   原代销者身份证号
                      v.value = res.data.rows[0].agentInfo.idCard;
                    }else if(v.id==='distributorsidentity'){
                      //   原代销者身份证号
                      v.value = res.data.rows[0].agentInfo.idCard;
                    }else if(v.id==='managementkind'){
                      // 经营类型
                      let a = res.data.rows[0].branchType==='1'?'福彩':'福体';
                      let b = res.data.rows[0].businessType==='1'?'专营':'兼营';
                      v.value = a+b;
                    }else if(v.id==='management_kind'){
                      // 经营类型
                      let a = res.data.rows[0].branchType==='1'?'福彩':'福体';
                      let b = res.data.rows[0].businessType==='1'?'专营':'兼营';
                      v.value = a+b;
                    }
                  });
                }
              }else{
                // 网点录入  查重
                if(processDefinitionName.indexOf('网点录入')!==-1){
                  this.$toast('该网点编号可以使用！');
                  this.innerLoading = false;
                }else{
                  this.$toast(`${siteId}站点暂无数据！`);
                }
              }
            }else{
              this.$toast(res.data.msg);
            }
            this.innerLoading = false;
          }
        }
      });
    },
    async getFixedTwoLatLon(index){
      if(this.variablesObj&&this.variablesObj.hiddenCoordinates){
        const cordResult = await this.fixedLatLon({
          coord:this.variablesObj.hiddenCoordinates,
          coord1:this.formFields[index].value
        });
        if(!cordResult.state){
          this.$toast(cordResult.explain);
          return false;
        }
      }
    },
    fixedLatLon(data){
      return new Promise(resolve => {
        // 后端接口返回
        processIsCord(data).then((resData) => {
          let res = resData.data;
          console.log(res)
          if (res) {
            if (res.code && res.code === 200) {
              resolve(res.data);
            } else {
              if (res.msg) {
                this.$toast(res.msg);
              }
            }
          }
        });
      });
    },
    getFixedLocal(latitude,longitude,index,type){
      let params = {
        latitude: latitude,
        longitude: longitude,
      }
      // 巡检时，增加一个网点编号的字段
      if(type==='fixed-site'){
        params.branchId = this.siteIdObj.branchId?this.siteIdObj.branchId:'';
      }
      branchInfoJudgeDistance(params).then((res) => {
        if(res){
          if(res.data){
            if(res.data.data){
              if(type==='fixed-site'){
                // true：本人在附近
                // true:可以 false:不可以
                this.formFields[index].value = latitude+','+longitude;
              }else{
                // true 是可以申请，200米内没有网点
                this.formFields[index].value = '否';
                this.formFields[index].valueMsg = res.data.msg;
                this.formFields[index].valuesFlags = true;
              }
            }else{
              if(type==='fixed-site'){
                //false ：是 是本人不在网点附近
                Dialog.alert({
                  title: '提示',
                  message: `
                    <div class="innerDialog">
                      <div style="text-align: left;">您当前的位置不在网点附近，请前往门店进行巡检。</div>
                    </div>`,
                  confirmButtonText: '确定',
                  theme: 'round-button',
                }).then(() => {
                  console.log('位置偏移过大')
                  // this.showPopup = false;
                  this.getApiDel();
                });
              }else {
                // false 是可以不申请，200米内有网点
                this.formFields[index].value = '是';
                this.formFields[index].valueMsg = res.data.msg;
                this.formFields[index].valuesFlags = false;
              }
            }
          }
        }
      });
    },
    // 新建流程未提交的流程，关闭页面执行删除操作
    // resetForm(){
    //   // 有历史数据的，不删流程，只有新创建的流程删
    //   if(this.content==='del'){
    //     if (!this.isManClose) {
    //       this.innerLoading = true;
    //       this.getApiDel();
    //     }
    //   }else{
    //     this.showPopup = false;
    //     this.innerLoading = false;
    //   }
    // },
    // 新建流程未提交的流程，关闭页面执行删除操作
    cancel() {
      // 有历史数据的，不删流程，只有新创建的流程删
      if(this.content==='del'){
        this.innerLoading = true;
        this.getApiDel();
      }else{
        this.innerLoading = false;
        this.$router.go(-1)
      }
    },
    // 新建流程未提交的流程，关闭页面执行删除操作
    getApiDel() {
      processRemove({
        processInstanceId: this.returnObj.processInstanceId
      }).then((res) => {
        if (res) {
          if (res.data) {
            if (res.data.code === 200) {
              this.$router.go(-1)
              this.$emit('submit', {});
            } else {
              this.$toast(res.data.msg);
            }
            this.innerLoading = false;
          }
        }
      });
    },
    // 下拉框选择单条数据，展示弹框
    getSelect(item) {
      this.itemObj = item;
      this.showPicker = true;
    },
    // 选择数据后，传回父级组件内回显
    getPop(data) {
      this.formFields.map((v) => {
        if (v.name === data.name) {
          v.value = data.value;
        }
      });
    },
    // 时间（年月日）选择器
    getDateSelect(item,type){
      this.itemObj = item;
      this.showDatePicker = true;
    },
    // 选择数据后，传回父级组件内回显
    getDateTemp(data){
      this.formFields.map((v) => {
        if (v.name === data.name) {
          v.dateValueFlag = false;
        }
      });
    },
    // 字符串内过滤斜杠/
    removeSlashes(str) {
      return str.replace(/\//g, '');
    },
    validateInput(field){
      // 正则表达式：允许中文、英文、数字、常见标点符号
      const pattern = /^[\u4e00-\u9fa5a-zA-Z0-9\s.,;:!?，。、；：！？'"‘’“”《》【】（）{}\[\]\-—~…]+$/;
      if (field.value && !pattern.test(field.value)) {
        // 自动移除非法字符
        field.value = field.value.replace(/[^\u4e00-\u9fa5a-zA-Z0-9\s.,;:!?，。、；：！？'"‘’“”《》【】（）{}\[\]\-—~…]/g, '');
      }
      if(field.id==='oldAddress'){
        const maxLength = 20;
        if (field.value.length > maxLength) {
          field.value = field.value.slice(0, maxLength);
        }
      }else if(field.id==='newAddress'){
        const maxLength = 20;
        if (field.value.length > maxLength) {
          field.value = field.value.slice(0, maxLength);
        }
      }else if(field.id==='address'){
        const maxLength = 20;
        if (field.value.length > maxLength) {
          field.value = field.value.slice(0, maxLength);
        }
      }
    },
    // 输入框校验
    getRules(field) {
      if (field.required) {
        const baseRules = [
          {
            validator: (val) => this.validateRequired(val, field.name),
            message: `请输入${field.name}`
          }
        ]
        switch (field.id_name) {
          case 'name':
            return [...baseRules,
              {validator: this.validateName, message: '请检查，格式不正确'}
            ]
          case 'phone':
            return [...baseRules,
              {validator: this.validatePhone, message: '请检查，格式不正确'}
            ]
          case 'identity':
            return [...baseRules,
              {validator: this.validateIdCard, message: '请检查，格式不正确'}
            ]
          default:
            return baseRules
        }
      }
      // return this.rulesConfig[fieldName] || []
    },
    validateRequired(val) {
      return !(val === null || val === undefined || val === '');
    },
    // 校验姓名
    validateName(val) {
      if (!blurRule(val, {name: 'name'})) {
        return false;
      }
    },
    // 校验手机号
    validatePhone(val) {
      // 只允许输入数字和符号，未校验位数
      if (!validateInput(val)) {
        return false;
      }
      // 电话号码校验正则
      // if(!blurRule(val, {name: 'phone'})){
      //   return false;
      // }
    },
    // 校验身份证号
    validateIdCard(val) {
      if (!blurRule(val, {name: 'idCard'})) {
        return false;
      }
    },
    // 图片放大
    showPreview(index, item) {
      ImagePreview({
        images: item,
        startPosition: index,
        closeable: true,
      });
    },
    getWechatLocation(event, index, type) {
      event.preventDefault(); // 阻止默认行为
      let that = this;
      // // 测试数据用   start
      // that.formFields[index].value = this.latitude+','+this.longitude;
      // // 测试数据用   end
      let url = window.location.href.split('#')[0];
      if (url) {
        // 接口返回appid和签名类的数据
        this.$http.weChatScan_preScan({
          url: url,
        }).then((res) => {
          if (res && res.data) {
            // // 测试本地用
            // if (type !== 'site') {
            //   // 计算并检查附是否有近站点
            //   that.getFixedLocal(that.latitude, that.longitude, index, type);
            // } else {
            //   that.formFields[index].value = that.latitude + ',' + that.longitude;
            //   that.getFixedTwoLatLon(index);
            // }
            // console.log('第二步：验证签名接口返回数据，进入wx.config执行');
            wx.config({
              debug: false, // 开启调试模式,
              appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号cor pid
              timestamp: res.data.timestamp, // 必填，生成签名的时间戳
              nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
              signature: res.data.signature,// 必填，签名，见附录1
              jsApiList: [
                'getLocation',
                // 'chooseImage',
                // 'scanQRCode',
                // 'getLocalImgData',
                // 'openCustomerServiceChat',
                // 'updateAppMessageShareData',
                // 'updateTimelineShareData', // 需要使用的JSAPI列表
                // 'onMenuShareTimeline', // 旧版朋友圈分享（兼容）
                // 'onMenuShareAppMessage' // 旧版好友分享（兼容）
              ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });
            wx.ready(() => {
              console.log('ggg')
              wx.getLocation({
                type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入' gcj02 '
                success: function (data) {
                  console.log('成功', data);
                  if (type !== 'site') {
                    that.getFixedLocal(data.latitude, data.longitude, index, type);
                  } else {
                    that.formFields[index].value = data.latitude + ',' + data.longitude;
                    that.getFixedTwoLatLon(index);
                  }
                },
                fail: err => {
                  console.log('wx.getLocation方法 ，失败');
                  console.log('失败', err);
                  console.log(err.errMsg);
                  if (err.errMsg.includes('user deny')) {
                    that.$toast = '您拒绝了位置授权，请前往设置开启';
                  } else {
                    that.$toast = `获取位置失败：${err.errMsg}`;
                  }
                }
              });
            });
            wx.error(error => {
              // this.$toast.fail('验证签名失败，无法获得微信分享功能')
              console.error('---wx.config---SDK初始化失败------');
              console.error(error)
              console.error(error.errMsg)
              //   Dialog.alert({
              //     title: '获取地理位置失败',
              //     message: `
              //     <div class="innerDialog">
              //       <div style="text-align: left;">点击刷新按钮，系统会给您授权地理位置的提示，请您务必选择允许按钮。</div>
              //     </div>`,
              //     confirmButtonText: '刷新',
              //     theme: 'round-button',
              //   }).then(() => {
              //     // 刷新页面
              //     location.reload();
              //   });
            });
          } else {
            that.$toast('请求出错！')
          }
        });
      }
    },
    async onSubmit() {
      if (this.flowNameObj && this.flowNameObj.processDefinitionName) {
        const service = await this.onIsinserviceReturn();
        if (service) {
          this.$toast('当前网点正在流程中，不可重复操作！');
          return false;
        }
      }


      const emptyField = this.formFields.find(item => !item.value);
      if (emptyField) {
        if (emptyField.required) {
          this.$toast(`请完善 ${emptyField.name} 信息！`);
          return false;
        }
      }
      this.formFields.length>0&&this.formFields.map((v) => {
        if (v.socre) {
          v.scoreValueFlag = false;
          v.value = v.socre;
        }else if(v.dateValue){
          v.dateValueFlag = false;
          v.value = v.dateValue;
        }
        // if(v.required){
        //   if(v.files&&v.files.length<2){
        //     this.$toast(`请完善 ${v.name} 信息！`);
        //     return false;
        //   }
        // }
      });
      // this.innerLoading = true;
      // 提交前已做表单校验
      // 转变格式
      //把数组格式 类似 [{name:'city',value:'拉萨市'},{'name':'siteId',value:'54010001'}]
      //转变为对象 {city:'拉萨市',siteId:'54010001'}
      const result = this.formFields.reduce((obj, item) => {
        obj[item.id] = item.value;
        return obj;
      }, {});
      let processDefinitionName = '';
      if (this.returnObj.processDefinitionName) {
        processDefinitionName = this.returnObj.processDefinitionName;
      } else if (this.siteIdObj.processDefinitionName) {
        processDefinitionName = this.siteIdObj.processDefinitionName;
      } else if (this.flowNameObj.processDefinitionName) {
        processDefinitionName = this.flowNameObj.processDefinitionName;
      }
      this.createObj.processDefinitionName = processDefinitionName;//
      // this.returnObj.processDefinitionName?this.returnObj.processInstanceId:this.returnObj.variables.processInstanceId;
      this.createObj.processInstanceId = this.returnObj.processInstanceId ? this.returnObj.processInstanceId : this.returnObj.variables.processInstanceId;
      this.createObj.formId = this.formDefine.id;
      this.createObj.taskId = this.returnObj.taskId ? this.returnObj.taskId : this.returnObj.variables.taskId;
      this.createObj.values = result;
      console.log(this.createObj)
      // return;
      // 校验网点录入表单时，库里是否有，如果有，则无法提交，反之，可以提交
      if(processDefinitionName.indexOf('网点录入')!==-1){
        let paramsData = {
          city:result.city,//地区、
          identity:result.identity,//身份证、
          phone:result.phone,//手机号
          siteid:result.siteid,//网点
        }
        if(result.city&&result.city&&result.city&&result.phone){
          const bindResult = await this.onIsMobileBindReturn(paramsData);
          if(!bindResult.state){
            this.$toast(bindResult.explain);
            return false;
          }
        }
      }
      console.log(this.variablesObj)
      console.log(this.variablesObj.hiddenCoordinates)
      console.log(result.noCoord)
      if(this.variablesObj&&this.variablesObj.hiddenCoordinates&&result.noCoord){
        const cordResult = await this.fixedLatLon({
          coord:this.variablesObj.hiddenCoordinates,
          coord1:result.noCoord
        });
        if(!cordResult.state){
          this.$toast(cordResult.explain);
          return false;
        }
      }
      if(this.createObj.taskId&&this.createObj.processDefinitionName){
        processGeneralsubmit(this.createObj).then((res) => {
          if (res) {
            if (res.data) {
              if (res.data.code === 200) {
                // 传给父组件，调取提交接口
                this.$emit('submit', this.createObj);
                this.$toast.success(res.data.msg);
                this.$router.go(-1);
              } else {
                this.$toast.fail(res.data.msg);
              }
              this.innerLoading = false;
            }
          }
        });
      }else{
        this.innerLoading = false;
        this.$toast('请稍后！');
      }
    }
  }
}
</script>
<template>
  <div class="temp-warp">
    <!--    单选下拉-->
    <!--    <Pop v-model="showPicker" :itemObj="itemObj" @submit="getPop"></Pop>-->
    <!--    时间选择-->
    <!--    <Date-temp v-model="showDatePicker" :itemObj="itemObj" @submit="getDateTemp"></Date-temp>-->
    <div class="temp-inner">
      <van-form @submit="onSubmit">
        <!--    加载中...-->
        <inner-loading v-model="innerLoading"></inner-loading>
        <div class="card-form">
          <div class="fixed-close" @click="cancel"><van-icon name="arrow-left" class="font" /></div>
          <div class="section-title" v-if="formDefine&&formDefine.name">
            {{ formDefine.name.split('-')[1] }}
          </div>
          <div class="section-title" v-else>详情信息</div>
          <div class="history-card" v-if="filteredActivities.length>0">
            <div class="card" v-for="(v,index) in filteredActivities" :key="index">
              <div class="card-title-item" v-if="v&&v.taskName">{{ v.taskName }} - {{ v.handler }}</div>
              <div class="info-form-group" v-if="v&&v.formInfo&&v.formInfo.fields" v-for="(item,k) in v.formInfo.fields" :key="k">
                <div class="info-form-item">
                  <div class="info-label-content">{{ item.name }}：</div>
                  <div class="info-text-content" v-if="item.params.customDesign.type==='rate'">
                    <van-rate
                        v-model="item.value"
                        :readonly="item.readOnly"
                        :size="25"
                        :count="5"
                        color="#ffd21e"
                        void-icon="star"
                        void-color="#eee"
                    />
                  </div>
                  <div v-else-if="item.params.customDesign.type==='fileupload'" class="imageEnd">
                    <div class="group-video" v-if="item.files.length>0">
                      <div class="group-video-load">
                        <van-image
                            v-for="(val,kes) in item.files" :key="kes"
                            :src="val"
                            @click="showPreview(kes,item.files)"
                        />
                      </div>
                    </div>
                    <div v-else>未填写说明</div>
                  </div>
                  <div class="info-text-content" v-else>
                    <span v-if="item.id==='phone'">
                      <a :href="'tel:'+item.value">{{ item.value }}</a>
                    </span>
                    <span v-else-if="item.id==='distributorsphone'">
                      <a :href="'tel:'+item.value">{{ item.value }}</a>
                    </span>
                    <span v-else-if="item.id==='distributorphone'">
                      <a :href="'tel:'+item.value">{{ item.value }}</a>
                    </span>
                    <span v-else-if="item.id==='previousphone'">
                      <a :href="'tel:'+item.value">{{ item.value }}</a>
                    </span>
                    <!--新代销者手机号-->
                    <span v-else-if="item.id==='nowphone'">
                      <a :href="'tel:'+item.value">{{ item.value }}</a>
                    </span>
                    <span v-else>
                    {{ item.value ? removeSlashes(item.value) : '未填写说明' }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-item" v-if="formFields.length>0" v-for="(item,index) in formFields" :key="index">
            <div class="form-label">
              {{ item.name }} <span style="color: red" v-show="item.required">*</span>
              <div v-if="item.id==='isSiteid'" style="display: inline-block;margin-left: 20px;float: right;">
                <button class="verification-button">
                  <span @click.prevent="getWechatLocation($event,index,'noSite')">检查附近网点</span>
                </button>
              </div>
            </div>
            <div v-if="item.params.customDesign.type==='input'">
              <!-- 经纬度字段单独处理-->
              <div v-if="item.id==='coord'" class="verification-group">
                <input type="text" class="form-input verification-input" style="background: #dfdfdf;" autocomplete="off"
                       readonly="readOnly" v-model="item.value" placeholder="获取经纬度信息"/>
                <button class="verification-button" :class="item.value?'ver-success':''">
                  <span
                      @click.prevent="getWechatLocation($event,index,'fixed-site')">{{ item.value ? '已获取' : '获取定位' }}</span>
                </button>
              </div>
              <div v-else-if="item.id==='noCoord'||item.id==='hiddenCoordinates'" class="verification-group">
                <input type="text" class="form-input verification-input" style="background: #dfdfdf;" autocomplete="off"
                       readonly="readOnly" v-model="item.value" placeholder="获取经纬度信息"/>
                <button class="verification-button" :class="item.value?'ver-success':''">
                  <span
                      @click.prevent="getWechatLocation($event,index,'site')">{{ item.value ? '已获取' : '获取定位' }}</span>
                </button>
              </div>
              <van-field
                  v-model="item.value"
                  name="name"
                  label=""
                  v-else
                  :type="item.id==='siteid'?'digit':''"
                  autocomplete="off"
                  :readonly="item.readOnly"
                  @input="validateInput(item)"
                  :placeholder="`${item.params.customDesign.placeholder}${item.name}`"
                  :rules="item.required?getRules(item):[]"
              />
            </div>
            <div v-else-if="item.params.customDesign.type==='textarea'">
              <van-field
                  v-if="item.id==='address'||item.id==='oldAddress'||item.id==='newAddress'"
                  v-model="item.value"
                  name="name"
                  label=""
                  autocomplete="off"
                  :readonly="item.readOnly"
                  type="textarea"
                  @input="validateInput(item)"
                  :placeholder="`${item.params.customDesign.placeholder}${item.name}`"
                  :rules="item.required?getRules(item):[]"
                  rows="2"
                  autosize
                  maxlength="20"
                  show-word-limit
              />
              <van-field
                  v-else
                  v-model="item.value"
                  name="name"
                  label=""
                  autocomplete="off"
                  :readonly="item.readOnly"
                  type="textarea"
                  @input="validateInput(item)"
                  :placeholder="`${item.params.customDesign.placeholder}${item.name}`"
                  :rules="item.required?getRules(item):[]"
              />
            </div>
            <div v-else-if="item.params.customDesign.type==='select'">
              <van-field
                  v-model="item.value"
                  name=""
                  label=""
                  readonly
                  :placeholder="`${item.params.customDesign.placeholder}${item.name}`"
                  @click="getSelect(item)"
                  :rules="[{ required: true, message: `${item.params.customDesign.placeholder}${item.name}` }]"
              >
                <template #right-icon>
                  <van-icon name="arrow-down"/>
                </template>
              </van-field>
            </div>
            <div v-else-if="item.params.customDesign.type==='radio'" style="display: flex;flex-direction: row;justify-content: space-between">
              <van-radio-group v-model="item.value" direction="horizontal" style="display: flex;align-items: center">
                <van-radio :name="val.label" v-for="(val,k) in item.params.customDesign.values" :key="k">
                  {{ val.label }}
                </van-radio>
              </van-radio-group>
              <!-- 检查附近网点-->
              <div v-if="item.id==='isSiteid'" style="float: right">
                <span v-if="!item.valuesFlags" style="color:red;text-align: right">{{ item.valueMsg }}</span>
                <span v-else style="color:green;">{{ item.valueMsg }}</span>
              </div>
            </div>
            <div v-else-if="item.params.customDesign.type==='rate'">
              <van-rate
                  v-if="item.scoreValueFlag"
                  v-model="item.value"
                  :size="25"
                  :count="5"
                  color="#ffd21e"
                  void-icon="star"
                  void-color="#eee"
                  @change="onChange(index)"
              />
              <van-rate
                  v-else
                  v-model="item.scoreValue"
                  :size="25"
                  :count="5"
                  color="#ffd21e"
                  void-icon="star"
                  void-color="#eee"
                  @change="onValueChange(index)"
              />
            </div>
            <!--   年月日格式：yyyy-mm-dd -->
            <div v-else-if="item.params.customDesign.type==='date'">
              <van-field
                  v-model="item.value"
                  v-if="item.dateValueFlag"
                  name=""
                  label=""
                  readonly
                  :placeholder="`${item.params.customDesign.placeholder}${item.name}`"
                  @click="getDateSelect(item,'value')"
                  :rules="[{ required: true, message: `${item.params.customDesign.placeholder}${item.name}` }]"
              >
                <template #right-icon>
                  <van-icon name="arrow-down"/>
                </template>
              </van-field>
              <van-field
                  v-model="item.dateValue"
                  v-else
                  name=""
                  label=""
                  readonly
                  :placeholder="`${item.params.customDesign.placeholder}${item.name}`"
                  @click="getDateSelect(item,'dateValue')"
                  :rules="[{ required: true, message: `${item.params.customDesign.placeholder}${item.name}` }]"
              >
                <template #right-icon>
                  <van-icon name="arrow-down"/>
                </template>
              </van-field>
            </div>
            <div v-else-if="item.params.customDesign.type==='fileupload'">
              <div class="group-video">
                <div class="group-video-load">
                  <el-upload
                      class="avatar-uploader"
                      :action="fileVideoUrl"
                      :headers="headers"
                      :limit="2"
                      multiple
                      :file-list="item.files"
                      accept="image/jpeg, image/jpg, image/png"
                      list-type="picture-card"
                      :on-exceed="handleExceed"
                      :on-success="(response, file, fileList) => handleSuccess(response, file, fileList, index)"
                      :before-upload="beforeUploadImg1"
                      :on-remove="(file, fileList) => handleRemove(file, fileList, index)">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </div>
              </div>
            </div>
          </div>
          <div class="form-buttons">
            <van-button round block plain type="default" @click="cancel"
                        native-type="button">返回
            </van-button>
            <van-button round block type="primary" color="#e62d2d" v-if="content==='del'||submitText==='提交'"
                        native-type="submit">提交
            </van-button>
          </div>
        </div>
      </van-form>
    </div>
  </div>
</template>

<style scoped lang="scss">
.temp-warp{
  height: 100vh;
  width: 100vw;
  background: #fff;
  .temp-inner{
  background: #fff;
  }
}
.loading {
  z-index: 9999;
}
.form-buttons{
  padding: 0 20px 20px;
  box-sizing: border-box;

}
.form-item{
  padding: 0 20px;
  box-sizing: border-box;
}
.history-card {
  padding: 10px 20px 20px;
  border-bottom: 2px solid #ddd;
  margin-bottom: 20px;
  box-sizing: border-box;
  .card-title-item {
    text-align: left;
    font-weight: bold;
    padding-bottom: 10px;
    margin-bottom: 10px;
    font-size: 32px;
    border-bottom: 2px #ddd dashed;
  }
}

.card {
  box-shadow: var(--shadow-blod);
}

.card-form {
  //padding: 0 40px;
  box-sizing: border-box;

  .fixed-close {
    position: absolute;
    left: 30px;
    top: 10px;
    font-size: 50px;
    color: #fff;
  }
}

.section-title {
  padding-top: 20px;
  padding-bottom: 20px;
  justify-content: center;
  //border-bottom: 2px solid rgba(0, 0, 0, 0.05);
  color: #fff;
  background: linear-gradient(135deg, var(--primary-color), var(--primary-dark));
}

.van-cell {
  background: #f9f9f9;
}

.info-form-group {
  display: flex;
  flex-direction: column;

  .info-form-item {
    width: 100%;
    display: flex;
    flex-direction: row;
    .info-label-content {
      display: flex;
      font-weight: bold;
      color: #222;
      width: 50%;
    }

    .info-text-content {
      display: flex;
      width: 50%;
      justify-content:flex-end;
      align-items: flex-start;
      word-wrap: break-word;
      white-space: normal;
      span{
        text-align: right;
      }
    }
    .imageEnd{
      display: flex;
      width: 50%;
      justify-content:flex-end;
      align-items: flex-start;
    }
  }
}

.group-video {
  border-radius: 8px;
  //height: 26vw;
  //height: 260px;
  position: relative;

  .group-video-load {
    position: relative;
    border-radius: 10px;
    height: 100%;
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: row;

    .van-image {
      display: flex;
      max-width: 240px;
      height: 180px;
      border-radius: 8px;
      margin-right: 20px;

      /deep/ .van-image__img {
        display: flex;
        max-width: 240px;
        max-height: 170px;
        border-radius: 8px;
      }
    }

    .image-box {
      max-width: 240px;
      height: 180px;
      border-radius: 8px;
      margin-right: 20px;

      img {
        display: flex;
        max-width: 240px;
        max-height: 170px;
        border-radius: 8px;
      }
    }

    .avatar-uploader {
      display: flex;
      width: 100%;
      height: 100%;
      align-items: center;
      overflow: hidden;

      .el-upload {
        width: 100%;
        height: 100%;
      }
    }
  }
}

/deep/ .el-upload-list--picture-card .el-progress {
  width: 100%;

  /deep/ .el-progress__text {
    text-align: center;
  }
}

/deep/ .el-progress-circle {
  width: 130px !important;
  height: 130px !important;
  margin: 0 auto;
}
</style>
